import { createFileRoute } from '@tanstack/react-router';

import EstimationVersionsPage from '@/pages/estimation-versions';

export const Route = createFileRoute('/estimation-versions/$projectId/')({
  component: EstimationVersionsPage,
  loader: ({ params }) => params,
});
